import {Injectable} from "@angular/core";
import {EvkHttpService} from "@evomatik/evk-common";
import {Observable} from "rxjs";

@Injectable()
export class ExpedientesDeleteService {

    constructor(
        private http: EvkHttpService
    ) {
    }

    deleteExpediente(idExpediente): Observable<any> {
        return this.http.put('/seaged-expedientes-service/expediente/baja-logica', idExpediente);
    }
}
